export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6899.abc021f2.jpg";